import { render, staticRenderFns } from "./historique.vue?vue&type=template&id=4bebd64b"
import script from "./historique.vue?vue&type=script&lang=js"
export * from "./historique.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports